import React from 'react'
import logo from './img/Bhakti Culture Curv logo.png'
import leftBanner from './modeling/banner.jpg'
import img1 from './modeling/img-1.jpg'
import img2 from './modeling/img-2.jpg'
import img3 from './modeling/img-6.jpg'
import img4 from './modeling/img-4.jpg'
import women1 from './modeling/img-1.jpg'
import women2 from './modeling/img-2.jpg'
import women3 from './modeling/img-10.jpg'
import men1 from './modeling/img-3.jpg'
import men2 from './modeling/img-5.jpg'
import men3 from './modeling/img-8.jpg'
import insta1 from './images/instagram-01.jpg'
import insta2 from './images/instagram-02.jpg'
import insta3 from './images/instagram-03.jpg'
import insta4 from './images/instagram-04.jpg'
import insta5 from './images/instagram-05.jpg'
import insta6 from './images/instagram-06.jpg'
import exp1 from './images/explore-image-01.jpg'
import exp2 from './images/explore-image-02.jpg'
import { FaBehance, FaEye, FaFacebook, FaInstagram, FaLinkedin, FaPaperPlane, FaQuoteLeft, FaShoppingCart, FaTwitter } from 'react-icons/fa'
import { FaStar } from 'react-icons/fa6'
import Slider from 'react-slick'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import Layout from './Components/Layout'
import shopImg from './img/gallary-1.jpg'

export default function LandingPage() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <>


            <Layout>

                <div class="main-banner" id="top">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="left-content">
                                    <div class="thumb">
                                        <div class="inner-content">
                                            <h4>We Are Bhakti Culture</h4>
                                            <span>Manufacturer of Ladiesware</span>
                                            <div class="main-border-button">
                                                <a href="#">Purchase Now!</a>
                                            </div>
                                        </div>
                                        <img src={leftBanner} alt=""></img>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="right-content">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="right-first-image">
                                                <div class="thumb">
                                                    {/* <div class="inner-content">
                                                        <h4>Women</h4>
                                                        <span>Best Clothes For Women</span>
                                                    </div>
                                                    <div class="hover-content">
                                                        <div class="inner">
                                                            <h4>Women</h4>
                                                            <p>Lorem ipsum dolor sit amet, conservisii ctetur adipiscing elit incid.</p>
                                                            <div class="main-border-button">
                                                                <a href="#">Discover More</a>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <img src={img1} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="right-first-image">
                                                <div class="thumb">
                                                    {/* <div class="inner-content">
                                                        <h4>Men</h4>
                                                        <span>Best Clothes For Men</span>
                                                    </div>
                                                    <div class="hover-content">
                                                        <div class="inner">
                                                            <h4>Men</h4>
                                                            <p>Lorem ipsum dolor sit amet, conservisii ctetur adipiscing elit incid.</p>
                                                            <div class="main-border-button">
                                                                <a href="#">Discover More</a>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <img src={img2} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="right-first-image">
                                                <div class="thumb">
                                                    {/* <div class="inner-content">
                                                        <h4>Kids</h4>
                                                        <span>Best Clothes For Kids</span>
                                                    </div>
                                                    <div class="hover-content">
                                                        <div class="inner">
                                                            <h4>Kids</h4>
                                                            <p>Lorem ipsum dolor sit amet, conservisii ctetur adipiscing elit incid.</p>
                                                            <div class="main-border-button">
                                                                <a href="#">Discover More</a>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <img src={img3} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="right-first-image">
                                                <div class="thumb">
                                                    {/* <div class="inner-content">
                                                        <h4>Accessories</h4>
                                                        <span>Best Trend Accessories</span>
                                                    </div>
                                                    <div class="hover-content">
                                                        <div class="inner">
                                                            <h4>Accessories</h4>
                                                            <p>Lorem ipsum dolor sit amet, conservisii ctetur adipiscing elit incid.</p>
                                                            <div class="main-border-button">
                                                                <a href="#">Discover More</a>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    <img src={img4} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="section" id="saree">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="section-heading">
                                    <h2>Saree's Latest</h2>
                                    <span>Details to details is what makes Bhakti Culture different from the other.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <Slider {...settings}>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={men1} className='img-fluid' alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Classic Spring</h4>
                                            <span>$120.00</span>

                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={men2} className='img-fluid' alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Air Force 1 X</h4>
                                            <span>$90.00</span>

                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={men3} className='img-fluid' alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Love Nana ‘20</h4>
                                            <span>$150.00</span>

                                        </div>
                                    </div>


                                </Slider>

                            </div>
                        </div>
                    </div>
                </section>
                <section class="section" id="kurti">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="section-heading">
                                    <h2>Kurti's Latest</h2>
                                    <span>Details to details is what makes Bhakti Culture different from the other .</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <Slider {...settings}>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={women1} className="img-fluid" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Classic Spring</h4>
                                            <span>$120.00</span>

                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={women2} className="img-fluid" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Air Force 1 X</h4>
                                            <span>$90.00</span>

                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
                                                    <li><a href="single-product.html"><FaEye /></a></li>
                                                    <li><a href="single-product.html"><FaStar /></a></li>
                                                    <li><a href="single-product.html"><FaShoppingCart /></a></li>
                                                </ul>
                                            </div>
                                            <img src={women3} className="img-fluid" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Love Nana ‘20</h4>
                                            <span>$150.00</span>

                                        </div>
                                    </div>


                                </Slider>

                            </div>
                        </div>
                    </div>
                </section>



                <Container>

                    <Row>
                        <Col lg={6} data-aos="fade-right">
                            <img src={shopImg} className='img-fluid' alt='about us' />
                        </Col>
                        <Col lg={6} data-aos="fade-left" className='left-content'>
                            <h2>About Us</h2>
                            <p className='text-justify mt-3'>
                                Welcome to <b>Bhakti Culture</b>, where tradition meets modern craftsmanship. We are proud manufacturers of premium women’s ethnic wear, specializing in beautifully crafted Kurti Pant Dupatta sets and elegant sarees. Our mission is to bring the rich heritage of Indian fashion to the forefront, blending timeless designs with contemporary styles to create outfits that make every woman feel special.
                            </p>
                            <p className='text-justify'>   At <b>Bhakti Culture</b>, we focus on quality and attention to detail, ensuring each piece reflects our commitment to excellence. We cater exclusively to wholesalers and resellers, offering a wide range of affordable, stylish, and high-quality ethnic wear collections that appeal to diverse tastes and preferences.
                            </p>
                            <p className='text-justify'>    Our dedication to customer satisfaction, efficient service, and on-time delivery has earned us the trust of our partners across the fashion industry. Whether you're looking to expand your collection or offer the latest trends to your clients, we’re here to help you succeed with every transaction.
                            </p>
                            <p className='text-justify'>     Thank you for choosing <b>Bhakti Culture</b>. We look forward to partnering with you and contributing to the success of your business.
                            </p>
                        </Col>
                    </Row>
                </Container>



                <section class="section" id="explore">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="left-content">
                                    <h2>Why Choose Us?</h2>
                                    <p className='text-dark'>1. What makes you a good choice for my ethnic wear business?</p>
                                    <span> We are a leading manufacturer, wholesaler, and stockist of women’s ethnic wear, offering a wide range of high-quality Kurtis, Pant Dupatta sets, and sarees. We make it easy for you to start or grow your business by providing flexibility, competitive pricing, and a wide variety of products.</span>
                                    <p className='text-dark'>2. Can I start my own business by reselling your products?</p>
                                    <span>   Yes! You can easily start your own reselling business with us. We offer a wide range of trendy and high-quality ethnic wear that will appeal to your customers, making it a great opportunity to enter the market.</span>
                                    <p className='text-dark'>3. Do I need to buy products in bulk to get started?</p>
                                    <span>  No, you don't need to invest in large quantities. We offer an order-based purchasing system, which means you can buy stock only as you need it. Our minimum order quantity is just 1 piece, allowing you to keep inventory costs low and reduce business risk.</span>
                                    <p className='text-dark'>4. What is the process for placing orders?</p>
                                    <span>    Simply place your order as needed, and we’ll fulfill it for you. With no minimum stock requirements beyond 1 piece, you have the freedom to manage your inventory as you grow.</span>


                                    <div class="main-border-button">
                                        <a href="/about">Discover More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="right-content">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="leather">
                                                <h4>Sarees </h4>
                                                <span>Latest Collection</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="first-image">
                                                <img src={men1} className='img-fluid' alt="" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="second-image">
                                                <img src={women1} alt="" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="types">
                                                <h4>Kurtis</h4>
                                                <span>Over 304 Products</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <div class="subscribe">
                    <div class="container">



                        <div class="row">
                            <div class="col-lg-3 col-md-4">
                                <ul>
                                    <li>Store Location:<br /><span>SHOP NO.88-89,  AVADH TEXTILE MARKET, UMARWADA, SAHARA DARWAJA,  OPP NEW BOMBAY MARKET, SURAT - 395101</span></li>


                                </ul>
                            </div>
                            <div class="col-lg-2 col-md-4">
                                <ul>
                                    <li>Phone:<br /><span>97278 28326</span></li>


                                </ul>
                            </div>
                            <div class="col-lg-2 col-md-4">
                                <ul>
                                    <li>Work Hours:<br /><span>07:30 AM - 9:30 PM Daily</span></li>


                                </ul>
                            </div>
                            <div class="col-lg-2 col-md-4">
                                <ul>
                                    <li>Email:<br /><span>info@bhakticulture.in</span></li>


                                </ul>
                            </div>

                            <div class="col-lg-2 col-md-4">
                                <ul>


                                    <li>Office Location:<br /><span>Surat</span></li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </Layout>


        </>
    )
}
